import { gql } from '@apollo/client';

export const GET_GIS_FILES_QUERY = gql`
  query gisFiles($page: Int, $perPage: Int) {
    gisFiles(page: $page, perPage: $perPage) {
      files {
        id
        uid
        name
        description
        s3Bucket
        s3Key
        isPublished
        createdAt
        updatedAt
        publishedAt
        country {
          id
          name
        }
        region {
          id
          name
        }
        createdBy {
          id
          firstName
          lastName
        }
        publishedBy {
          id
          firstName
          lastName
        }
      }
      totalCount
    }
  }
`;

export const CREATE_GIS_FILE_UPLOAD_URL_MUTATION = gql`
  mutation createGisFileUploadUrl($filename: String!) {
    createGisFileUploadUrl(filename: $filename) {
      uuid
      s3Key
      s3Bucket
      signedUrl {
        url
        fields
      }
      errors
    }
  }
`;

export const CREATE_GIS_FILE_MUTATION = gql`
  mutation createGisFile(
    $s3Bucket: String!,
    $s3Key: String!,
    $uuid: ID!,
    $name: String!,
    $description: String,
    $countryId: ID,
    $regionId: ID
  ) {
    createGisFile(
      s3Bucket: $s3Bucket,
      s3Key: $s3Key,
      uuid: $uuid,
      name: $name,
      description: $description,
      countryId: $countryId,
      regionId: $regionId
    ) {
      gisFile {
        id
        name
        description
        s3Bucket
        s3Key
        isPublished
        createdAt
        updatedAt
        country {
          id
          name
        }
        region {
          id
          name
        }
      }
      errors
    }
  }
`;

export const PUBLISH_GIS_FILE_MUTATION = gql`
  mutation publishGisFile($id: ID!) {
    publishGisFile(id: $id) {
      gisFile {
        id
        name
        description
        s3Bucket
        s3Key
        isPublished
        createdAt
        updatedAt
        publishedAt
        country {
          id
          name
        }
        region {
          id
          name
        }
        createdBy {
          id
          firstName
          lastName
        }
        publishedBy {
          id
          firstName
          lastName
        }
      }
      errors
    }
  }
`;

export const GET_DOWNLOAD_URL_MUTATION = gql`
  mutation getGisFileDownloadUrl($id: ID!) {
    getGisFileDownloadUrl(id: $id) {
      url
      errors
    }
  }
`;